import React from "react";

export const HalfStar = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38" fill="none">
      <g clipPath="url(#clip0_341_35028)">
        <path
          d="M34.6821 14.3954L23.4805 13.4295L19.1027 3.11588L14.7249 13.445L3.52325 14.3954L12.0296 21.7644L9.47459 32.7168L19.1027 26.9056L28.7308 32.7168L26.1913 21.7644L34.6821 14.3954ZM19.1027 23.9923V9.50344L21.7668 15.7975L28.5905 16.3895L23.4182 20.8764L24.9761 27.5444L19.1027 23.9923Z"
          fill="#FEB312"
        />
      </g>
      <defs>
        <clipPath id="clip0_341_35028">
          <rect width="37.3906" height="37.3906" fill="white" transform="translate(0.407349)" />
        </clipPath>
      </defs>
    </svg>
  );
};
